export function toDebugString(input) {
  if (typeof input !== "object" || input == null) {
    return input;
  }
  if ("ref" in input) {
    return "$".concat(toDebugString(input.ref));
  }
  if ("fn" in input) {
    return "".concat(input.fn, "(").concat((input.argv || []).map(toDebugString).join(", "), ")");
  }
  return JSON.stringify(input, null, 2);
}